<div fxLayout="column" fxFill>
    <flex-table #flexTable [noHeader]="true" fxFill fxFlex [dataSource]="dataSource" [tableConfig]="tableConfig"
        [columnTemplates]="{content: tplCallInfo}">

        <ng-template #tplIcon let-item="row">
            <div fxLayout="row" fxlayoutalign="center center">
                <button mat-icon-button type="button" *ngIf="item.is_missed == 1; else noMissed"
                    class="button-detail is-missed">
                    <mat-icon *ngIf="item.voicemail_public_id;else NoVoicemailBlock">mail_outline</mat-icon>
                    <ng-template #NoVoicemailBlock>
                        <mat-icon>call_missed</mat-icon>
                    </ng-template>
                </button>

                <ng-template #noMissed>
                    <button mat-icon-button type="button" class="button-detail">
                        <mat-icon *ngIf="item.user_direction === 2; else InboundBlock" class="mat-text-muted">north
                        </mat-icon>
                        <ng-template #InboundBlock>
                            <mat-icon class="call_in">south</mat-icon>
                        </ng-template>
                    </button>
                </ng-template>
            </div>
        </ng-template>

        <ng-template #tplCallInfo let-item="row">
            <div fxLayout="row" class="full-width" (click)="selectItem($event, item)">
                <div fxFlex="40px">
                    <ng-container *ngTemplateOutlet="tplIcon; context: {row: item}"></ng-container>
                </div>

                <div fxFlex fxLayout="column" fxLayoutAlign="start start">
                    <h3 [matTooltip]="(getPhoneNumber(item) | displayPhoneNumber) + (item.client_name ? ' ' + item.client_name : '')"
                        class="ma-0" [ngClass]="{'is-missed': item.is_missed}">
                        <span *ngIf="item.user_direction == 2; else CallingNumberBlock">
                            {{ ((item.called_number | displayPhoneNumber) + (item.client_name ? ' (' +
                            item.client_name + ')' : '')) | truncate }}
                        </span>
                        <ng-template #CallingNumberBlock>
                            {{ ((item.calling_number | displayPhoneNumber) + (item.client_name ? ' (' +
                            item.client_name + ')' : '')) | truncate }}
                        </ng-template>
                    </h3>
                    <p class="mat-text-muted mb-0 mt-0 text-md" [matTooltip]="getQueueName(item)"
                        *ngIf="item.queue_ids">
                        {{ getQueueName(item) | truncate }}
                    </p>
                </div>

                <div fxFlex="90px" fxLayoutAlign="end start">
                    <ng-container *ngTemplateOutlet="tplStartDate; context: {row: item}"></ng-container>
                </div>
            </div>
        </ng-template>

        <ng-template #tplStartDate let-item="row">
            <div class="mat-text-muted text-md full-width" fxLayout="column" fxlayoutalign="start start">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="icon-row">access_time</mat-icon>
                    <span>{{ item.start_time|dateInbox }}</span>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="icon-row">hourglass_empty</mat-icon>
                    <span>{{ item.duration | seconds_as_duration }}</span>
                </div>
            </div>
        </ng-template>

    </flex-table>
</div>
